<template>
  <div class="cookie-container" v-if="!isCookieAccepted">
    <div class="cookie-notice" style="padding-right: 10px">
      <span class="cookie-notice-text">
        <img class="cookie-img" src="../assets/IMGS/SVG/cookies.svg" alt="cookie">
        <p v-if="!isMobile" class="cookie-notice-desc">Мы используем файлы Cookie чтобы предоставить вам лучший опыт работы на нашем сайте.
          Продолжая работу на нашем сайте, вы соглашаетесь с нашей <a href="https://medmobil.ru/license.pdf" style="display: contents">политикой конфиденциальности</a></p>
        <p v-else class="cookie-notice-desc">Сайт использует файлы cookies. <a href="https://medmobil.ru/license.pdf" style="display: contents">Политика конфиденциальности</a></p>
      </span>
      <button class="small" style="width: 76px; height: 38px; font-size: 16.4px;" @click="acceptCookie">ОК</button>
    </div>
  </div>
</template>
  
<script>
import tools from '../assets/js/tools.js';

export default {
  data() {
    return {
      isMobile: false,
      isCookieAccepted: false,
    };
  },
  methods: {
    getMobileScreen() {
        if (screen.width <= 1024) {
            return true
        } else {
            return false
        }
    },
    acceptCookie() {
      // Сохраните статус принятия файла cookie в локальном хранилище или на сервере
      // Чтобы показывать уведомление только один раз
      localStorage.setItem('isCookieAccepted', true);
      this.isCookieAccepted = true;
    },
  },
  created() {
    this.isMobile = this.getMobileScreen()
    // Проверьте, принят ли уже файл cookie при загрузке компонента
    this.isCookieAccepted = localStorage.getItem('isCookieAccepted') === 'true';
    if (tools.isShowOnlyContent()) {
        this.isCookieAccepted = true;
    }
  },
};
</script>

<style lang="css" scoped src='@/assets/css/cookie.css'></style>
